<template>
    <div className="main-section">
        <img :src="require('@/assets/images/wm-promotion/main-section/8.png')" alt="" />
    </div>
</template>

<script>
export default {
    name: 'Wm1',
}
</script>

<style scoped lang="scss"></style>
